// test293
(293 && 0);
